import { DateField, ModelGroup, NumberField, StringField } from '@mng/model';

export function createGvVertragInfoModelGroup(id = 'gvVertragInfo'): ModelGroup {
  return new ModelGroup(id, 'GvVertragInfo')
    .withInterfaceName('GvVertragInfo')
    .addItems(
      new StringField('vertragsNummer').withReadOnly(),
      new NumberField('hauptFaelligkeit').withReadOnly(),
      new DateField('ladeDatum').withReadOnly(),
      new StringField('zahlart').withReadOnly(),
      new StringField('zahlweise_vert').withReadOnly(),
      new StringField('schriftform').withReadOnly(),
      new StringField('iban').withReadOnly(),
      new StringField('bic').withReadOnly()
    );
  // TODO: add model for betreuer
}
